<template>
  <div
    class="rs-searchresults__vue__sidebar"
    :class="{
      'rs-searchresults__vue__sidebar__is-expandable': isExpandable,
      'rs-searchresults__vue__sidebar__not-expandable': !isExpandable,
    }"
  >
    <!-- <div
      v-if="
        fetchedResults &&
        fetchedResults.filters &&
        fetchedResults.filters.languages
      "
      class="rs-searchresults__vue__sidebar__taxonomy"
      :class="{
        'rs-searchresults__vue__sidebar__taxonomy__is-expanded':
          isLanguageExpanded,
      }"
    >
      <h2>
        <button @click="onLanguageClick">
          <span>Language</span>
          <svg
            width="8"
            height="5"
            viewBox="0 0 8 5"
            transform="rotate(180)"
            transform-origin="4 3"
          >
            <path d="M4,0,8,5H0Z" fill="#272727" />
          </svg>
        </button>
      </h2>

      <div
        class="rs-searchresults__vue__sidebar__taxonomy__list"
        :style="languageStyle"
        ref="languageList"
      >
        <label
          v-for="term in fetchedResults.filters.languages"
          :key="term.slug"
        >
          <input
            type="checkbox"
            v-model="local_selectedLanguages"
            :value="term.slug"
          />
          <span v-html="term.name" />
          <span>({{ term.count }})</span>
        </label>
      </div>
    </div> -->

    <div
      v-if="
        fetchedResults &&
        fetchedResults.filters &&
        fetchedResults.filters.rs_format
      "
      class="rs-searchresults__vue__sidebar__taxonomy"
      :class="{
        'rs-searchresults__vue__sidebar__taxonomy__is-expanded':
          isFormatExpanded,
      }"
    >
      <h2>
        <button @click="onFormatClick">
          <span v-html="strings['Format']"></span>
          <svg
            width="8"
            height="5"
            viewBox="0 0 8 5"
            transform="rotate(180)"
            transform-origin="4 3"
          >
            <path d="M4,0,8,5H0Z" fill="#272727" />
          </svg>
        </button>
      </h2>

      <div
        class="rs-searchresults__vue__sidebar__taxonomy__list"
        :style="formatStyle"
        ref="formatList"
      >
        <label
          v-for="term in fetchedResults.filters.rs_format"
          :key="term.slug"
        >
          <input
            type="checkbox"
            v-model="local_selectedFormats"
            :value="term.slug"
          />
          <span v-html="term.name" />
          <!-- <span>({{ term.count }})</span> -->
        </label>
      </div>
    </div>

    <div
      v-if="
        fetchedResults &&
        fetchedResults.filters &&
        fetchedResults.filters.category
      "
      class="rs-searchresults__vue__sidebar__taxonomy"
      :class="{
        'rs-searchresults__vue__sidebar__taxonomy__is-expanded':
          isCategoryExpanded,
      }"
    >
      <h2>
        <button @click="onCategoryClick">
          <span v-html="strings['Category']"></span>
          <svg
            width="8"
            height="5"
            viewBox="0 0 8 5"
            transform="rotate(180)"
            transform-origin="4 3"
          >
            <path d="M4,0,8,5H0Z" fill="#272727" />
          </svg>
        </button>
      </h2>

      <div
        class="rs-searchresults__vue__sidebar__taxonomy__list"
        :style="categoryStyle"
        ref="categoryList"
      >
        <label v-for="term in fetchedResults.filters.category" :key="term.slug">
          <input
            type="checkbox"
            v-model="local_selectedCategories"
            :value="term.slug"
          />
          <span v-html="term.name" />
          <!-- <span>({{ term.count }})</span> -->
        </label>
      </div>
    </div>

    <hr />
  </div>
</template>

<script>
export default {
  props: {
    fetchedResults: Object,
    selectedLanguages: Array,
    selectedFormats: Array,
    selectedCategories: Array,
    isExpandable: Boolean,
    strings: Object,
  },
  watch: {
    isLanguageExpanded(value) {
      if (value) {
        let _commonStyle =
          "transition: height 0.25s cubic-bezier(0.6, 0, 0.4, 1), visibility 0s linear, opacity 0.25s 0.15s linear; visibility: visible; opacity: 1;";
        if (this.$refs.languageList && this.$refs.languageList.scrollHeight) {
          this.languageStyle =
            _commonStyle + `height: ${this.$refs.languageList.scrollHeight}px;`;
        }
      } else {
        let _commonStyle =
          "transition: height 0.25s cubic-bezier(0.6, 0, 0.4, 1), visibility 0.25s linear, opacity 0.15s linear; visibility: hidden; opacity: 0;";
        this.languageStyle = _commonStyle + "height: 0;";
      }
    },
    isFormatExpanded(value) {
      if (value) {
        let _commonStyle =
          "transition: height 0.25s cubic-bezier(0.6, 0, 0.4, 1), visibility 0s linear, opacity 0.25s 0.15s linear; visibility: visible; opacity: 1;";
        if (this.$refs.formatList && this.$refs.formatList.scrollHeight) {
          this.formatStyle =
            _commonStyle + `height: ${this.$refs.formatList.scrollHeight}px;`;
        }
      } else {
        let _commonStyle =
          "transition: height 0.25s cubic-bezier(0.6, 0, 0.4, 1), visibility 0.25s linear, opacity 0.15s linear; visibility: hidden; opacity: 0;";
        this.formatStyle = _commonStyle + "height: 0;";
      }
    },
    isCategoryExpanded(value) {
      if (value) {
        let _commonStyle =
          "transition: height 0.25s cubic-bezier(0.6, 0, 0.4, 1), visibility 0s linear, opacity 0.25s 0.15s linear; visibility: visible; opacity: 1;";
        if (this.$refs.categoryList && this.$refs.categoryList.scrollHeight) {
          this.categoryStyle =
            _commonStyle + `height: ${this.$refs.categoryList.scrollHeight}px;`;
        }
      } else {
        let _commonStyle =
          "transition: height 0.25s cubic-bezier(0.6, 0, 0.4, 1), visibility 0.25s linear, opacity 0.15s linear; visibility: hidden; opacity: 0;";
        this.categoryStyle = _commonStyle + "height: 0;";
      }
    },
  },
  data() {
    return {
      isLanguageExpanded: Boolean,
      isFormatExpanded: Boolean,
      isCategoryExpanded: Boolean,
      languageStyle: String,
      formatStyle: String,
      categoryStyle: String,
    };
  },
  computed: {
    local_selectedLanguages: {
      get() {
        return this.selectedLanguages;
      },
      set(value) {
        let _filteredSelection = value.filter((item) => {
          return !this.selectedLanguages.includes(item);
        });
        this.$emit("selected-languages-change-request", _filteredSelection);
      },
    },
    local_selectedFormats: {
      get() {
        return this.selectedFormats;
      },
      set(value) {
        let _filteredSelection = value.filter((item) => {
          return !this.selectedFormats.includes(item);
        });
        this.$emit("selected-formats-change-request", _filteredSelection);
      },
    },
    local_selectedCategories: {
      get() {
        return this.selectedCategories;
      },
      set(value) {
        this.$emit("selected-categories-change-request", value);
      },
    },
  },
  mounted() {
    if (this.isExpandable) {
      this.isLanguageExpanded = false;
      this.isFormatExpanded = false;
      this.isCategoryExpanded = false;
    } else {
      this.isLanguageExpanded = true;
      this.isFormatExpanded = true;
      this.isCategoryExpanded = true;
    }
  },
  methods: {
    onSelectedCategoriesChange(event) {
      this.$emit(
        "selected-categories-change-request",
        this.local_selectedCategories
      );
    },
    onLanguageClick() {
      if (this.isExpandable) {
        this.isLanguageExpanded = !this.isLanguageExpanded;
      }
    },
    onFormatClick() {
      if (this.isExpandable) {
        this.isFormatExpanded = !this.isFormatExpanded;
      }
    },
    onCategoryClick() {
      if (this.isExpandable) {
        this.isCategoryExpanded = !this.isCategoryExpanded;
      }
    },
  },
};
</script>
